// extracted by mini-css-extract-plugin
module.exports = {"header":"_header_header__mZTyR","logo":"_header_logo__BOT6j","backBtn":"_header_backBtn__3ZSl8"};